/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import {
  COUNTRY,
  GROUND_MOTION_METHOD,
  GROUND_MOTION_UPLOAD,
  INCLUDE_DESIGN_INTENSITIES,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import {
  selectRunOutputDBE,
  selectRunOutputMCE,
  selectHasGroundMotionData,
  selectIsGroundMotionMatch,
  selectRunOutputGroundMotionClosestVs30,
  selectUploadedGroundMotionReturnPeriods,
} from '#selectors/entities/models.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import GroundMotionSection from './GroundMotionSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { modelId, form } = ownProps;
  const { selectFormValues } = modelTypesByForm[form];
  const {
    [COUNTRY]: country,
    [GROUND_MOTION_METHOD]: method,
    [GROUND_MOTION_UPLOAD]: upload,
    [INCLUDE_DESIGN_INTENSITIES]: includeDesignIntensities,
  } = selectFormValues(
    state,
    INCLUDE_DESIGN_INTENSITIES,
    GROUND_MOTION_METHOD,
    GROUND_MOTION_UPLOAD,
    COUNTRY
  );

  const isGroundMotionMatch = selectIsGroundMotionMatch(state, { modelId, method, upload });
  const hasGroundMotionData = selectHasGroundMotionData(state, { modelId });
  const returnPeriods = selectUploadedGroundMotionReturnPeriods(state, { modelId });

  return {
    country,
    dbe: selectRunOutputDBE(state, { modelId }),
    mce: selectRunOutputMCE(state, { modelId }),
    groundMotionClosestVs30: selectRunOutputGroundMotionClosestVs30(state, { modelId }),
    showDesignIntensities: includeDesignIntensities === true,
    showGroundMotionTable: isGroundMotionMatch && hasGroundMotionData,
    showReturnPeriodInputs: isGroundMotionMatch && hasGroundMotionData,
    returnPeriodOptions: returnPeriods.map(rp => ({ value: rp, text: rp })),
  };
};

const GroundMotionContainer = connect(mapStateToProps)(GroundMotionSection);

export default GroundMotionContainer;
